






























































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import { MensagensDaApiEnum } from '@/types/_'

@Component
export default class ComponentModalCriarEditarEspecialidadeProcedimento extends Vue {
  @Prop({ required: true, default: 'CREATE' }) mode: string

  $refs!: { form: any }

  formRules: any = {
    valid: true,
    especialidadeId: [(v: any) => !!v || 'Campo obrigatório'],
    codigoProcedimento: [(v: string) => !!v || 'Campo obrigatório'],
  }

  loadCreate: boolean = false
  get loadingCreateOrUpdate() { return this.loadCreate }
  set loadingCreateOrUpdate(value: boolean) { this.loadCreate = value }

  get modalCriarEditarEspecialidadeProcedimento() { return this.getFinanceiroStore.modal.criarEditarEspecialidadeProcedimento }
  set modalCriarEditarEspecialidadeProcedimento(value: boolean) { this.getFinanceiroStore.setModal({ name: 'criarEditarEspecialidadeProcedimento', value }) }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get subEspecialidadesFiltradas() {
    const espId = this.getFinanceiroStore.itemEspecialidadeProcedimento.especialidadeId
    if (!espId) return []
    return this.getFinanceiroStore.itemsSubEspecialidade.filter((s: any) => s.especialidadeId === espId)
  }

  onEspecialidadeChange() {
    this.getFinanceiroStore.itemEspecialidadeProcedimento.subEspecialidadeId = null
  }

  async createOrUpdate() {
    this.loadingCreateOrUpdate = true

    if (this.$refs.form.validate()) {
      const request = this.mode === 'CREATE'
        ? await this.getFinanceiroStore.createEspecialidadeProcedimento()
        : await this.getFinanceiroStore.updateEspecialidadeProcedimento()

      if (request.success) {
        if (request.message === MensagensDaApiEnum.UNCHANGED_PAYLOAD && this.mode === 'EDIT') {
          EventBus.$emit('setSnackbar', { show: true, text: 'Nenhuma alteração foi realizada', icon: 'info', color: '#2196F3' })
          this.modalCriarEditarEspecialidadeProcedimento = false
          this.loadingCreateOrUpdate = false
          return
        }

        EventBus.$emit('setSnackbar', {
          show: true,
          text: `Especialidade procedimento ${this.mode === 'CREATE' ? 'criado' : 'atualizado'} com sucesso! ${String.fromCodePoint(0x1f642)}`,
          icon: 'done',
          color: '#2E7D32',
        })
        this.$emit('update-items-table', true)
        this.modalCriarEditarEspecialidadeProcedimento = false
      } else {
        EventBus.$emit('setSnackbar', {
          show: true,
          text: request.message ? `${request.message} ${String.fromCodePoint(0x1f615)}` : `Ocorreu um erro na requisição... ${String.fromCodePoint(0x1f615)}`,
          icon: 'warning',
          color: '#C62828',
        })
      }
    }

    this.loadingCreateOrUpdate = false
  }

  @Watch('modalCriarEditarEspecialidadeProcedimento')
  onChangeModal(value) {
    if (!value) {
      this.getFinanceiroStore.clearItemEspecialidadeProcedimento()
      this.getFinanceiroStore.clearOriginalItemEspecialidadeProcedimento()
      this.$refs.form.resetValidation()
    }
  }
}
